import { Client } from './Client';
import { SendingPool } from './SendingPool';
import { Transform } from './Transform';
import { sendEmail } from './email';

export { Client as BixelClient, SendingPool, Transform as BixelTransform, sendEmail };
